import { render, staticRenderFns } from "./QuestionBoxRadioButton.vue?vue&type=template&id=1292dd20&scoped=true"
import script from "./QuestionBoxRadioButton.vue?vue&type=script&lang=js"
export * from "./QuestionBoxRadioButton.vue?vue&type=script&lang=js"
import style0 from "./QuestionBoxRadioButton.vue?vue&type=style&index=0&id=1292dd20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1292dd20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1292dd20')) {
      api.createRecord('1292dd20', component.options)
    } else {
      api.reload('1292dd20', component.options)
    }
    module.hot.accept("./QuestionBoxRadioButton.vue?vue&type=template&id=1292dd20&scoped=true", function () {
      api.rerender('1292dd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/QuestionBoxRadioButton.vue"
export default component.exports